export const configurationMenuItems = [
  {
    identifier: 'dimensions',
    title: 'Abmessungen',
  },
  {
    identifier: 'roof',
    title: 'Dach',
  },
  {
    identifier: 'walls',
    title: 'Wände',
  },
];

export default configurationMenuItems;
